import AppConfig from '../control/config';
import AesUtils from './AesUtils';
import axios from 'axios';
import AppData from '../model/AppData';
import AppUtils from '../control/apputlis';
import DateUtils from '../control/dateutils';


axios.interceptors.response.use(response => {
    let result = response.data;
    if (typeof (result) == 'string') {
        result = AesUtils.decrypt(response.data);
        result = JSON.parse(result);
        if (result.code == 204) {// token 过期，重新登录
            AppData.logout();
        }
    }
    return result;
}, error => {
    return Promise.reject(error);
})



export default class Apis {

    static buildUrl(url, params) {
        let paramsArr = [];
        for (const k in params) {
            if (params.hasOwnProperty(k)) {
                const v = params[k];
                if (v || v == 0) {
                    paramsArr.push(k + "=" + encodeURIComponent(AesUtils.encrypt(v)));
                }
            }
        }
        if (paramsArr.length == 0) {
            return url;
        }
        url = url + "?" + paramsArr.join("&");
        return url;
    }

    static buildForms(params) {
        let formData = new FormData();
        for (const k in params) {
            if (params.hasOwnProperty(k)) {
                const v = params[k];
                formData.append(k, v);
            }
        }
        return formData;
    }

    static getUrl(method) {
        if (AppConfig.hostApi[AppConfig.hostApi.length - 1] == '/') {
            return AppConfig.hostApi + method;
        } else {
            return AppConfig.hostApi + '/' + method;
        }
    }

    static get(method, params = {}) {
        var url = Apis.getUrl(method);
        if (AppData.me.token && AppData.me.token.length > 0) {
            params.token = AppData.me.token;
            params.customer_id = AppData.me.customer_id;
        }
        params.client_channel = AppConfig.channelid;
        url = Apis.buildUrl(url, params);
        console.log('axios geturl====>', url, params);
        return axios.get(url);
    }

    static post(method, params, config) {
        var url = Apis.getUrl(method);
        return axios.post(url, params, config);
    }

    /**
     * 1（轮播图接口）
     */
    static encryptionBanner() {
        return Apis.get('app/encryptionBanner')
    }

    /**
     * 2（文字轮播接口）
     */
    static encryptionTxtShuff() {
        return Apis.get('app/encryptionTxtShuff')
    }
    /**
     * 3（主播分类推荐接口）
     */
    static encryptionTypeHostRecomm(type) {
        return Apis.get('app/encryptionTypeHostRecomm', { type: type });
    }

    /**
     * 3（主播分类推荐接口）
     */
    static getTypeRecommend() {
        return Apis.get('app/encryptionTypeHostRecomm', { is_has_video: '1' });
    }

    //分享
    static encryptionConfig() {
        console.log('encryptionConfig');
        return Apis.get('app/encryptionConfig');
    }


    static encryptionHostLive() {
        return Apis.get('app/encryptionHostLive');
    }

    static encryptionHostSearch(search_title, page) {
        return Apis.get('app/encryptionHostSearch', { search_title: search_title, page: page });
    }

    static encryptionSearchMatch(title) {
        return Apis.get('app/encryptionSearchMatch', { title: title });
    }

    static encryptionHostRecomm() {
        return Apis.get('app/encryptionHostRecomm');
    }

    static encryptionShowOneType() {
        return Apis.get('app/encryptionShowOneType');
    }

    static encryptionMatch(type, time) {
        return Apis.get('app/encryptionMatch', { type_id: type, time: time });
    }


    static encryptionHostMatch(type_id, id) {
        return Apis.get('app/encryptionHostMatch', { type_id: type_id, id: id });
    }

    static encryptionRecommMatch() {
        return Apis.get('app/encryptionRecommMatch');
    }

    static encryptionLeagueList(type_id) {
        return Apis.get('app/encryptionLeagueList', { type_id: type_id });
    }

    static encryptionAddress(type_id) {
        return Apis.get('app/encryptionAddress', { type_id: type_id });
    }

    static encryptionHostInfo(room_id) {
        return Apis.get('app/encryptionHostInfo', { room_id: room_id });
    }

    static encryptionChannle(customer_id, token) {
        return Apis.get('app/encryptionChannle', { customer_id: customer_id, token: token });
    }

    static encryptionAllChannle() {
        return Apis.get('app/encryptionAllChannle');
    }

    static encryptionCustomerLogin(phone, code, password) {
        return Apis.get('app/encryptionCustomerLogin', { phone: phone, code: code, password: password });
    }

    //获取手机验证码
    static encryptionSendCode(phone) {
        return Apis.get('app/encryptionSendCode', { phone: phone });
    }

    static encryptionPhoneCode(phone, code) {
        return Apis.get('app/encryptionPhoneCode', { phone: phone, code: code });
    }

    //获取钱包状态
    static encryptionTask() {
        return Apis.get('app/encryptionTask');
    }

    //领取奖励
    static encryptionTaskEnd(taskid) {
        return Apis.get('app/encryptionTaskEnd', { task_id: taskid });
    }

    //获取个人信息
    static encryptionShowCustomer() {
        return Apis.get('app/encryptionShowCustomer', {});
    }
    // 修改昵称
    static encryptionEditName(username) {
        return Apis.get('app/encryptionEditName', { username: username });
    }

    // 反馈
    static encryptionCustomerBack(content, contact) {
        return Apis.get('app/encryptionCustomerBack', { content: content, contact: contact });
    }

    // 主播认证
    static encryptionHostReal(name, hobby, union, contact, content) {
        return Apis.get('app/encryptionHostReal', { name: name, hobby: hobby, union: union, contact: contact, content: content });
    }


    static encryptionUpdateChannle(channel) {
        return Apis.get('app/encryptionUpdateChannle', { channel: channel });
    }

    static encryptionRecommType() {
        return Apis.get('app/encryptionRecommType');
    }

    static encryptionRecommLive(com_id, type_id) {
        return Apis.get('app/encryptionRecommLive', { com_id: com_id, type_id: type_id });
    }

    static encryptionMatchGroup(type_id, match_id) {
        return Apis.get('app/encryptionMatchGroup', { type_id: type_id, match_id: match_id });
    }


    static encryptionInGroup(nickname, groupId) {
        return Apis.get('app/encryptionInGroup', { nickname: nickname, groupId: groupId });
    }

    static encryptionFocusHost(host_id, del) {
        return Apis.get('app/encryptionFocusHost', { host_id: host_id, del: del });
    }

    static encryptionShowFocusHost() {
        return Apis.get('app/encryptionShowFocusHost');
    }

    static encryptionDetailLive(type_id, match_id) {
        return Apis.get('app/encryptionDetailLive', { type_id: type_id, match_id: match_id });
    }

    static encryptionGetIntelligence(type_id, match_id) {
        return Apis.get('app/encryptionGetIntelligence', { type_id: type_id, match_id: match_id });
    }

    static encryptionMatchDetail(type_id, jump_event_id) {
        return Apis.get('app/encryptionMatchDetail', { type_id: type_id, jump_event_id: jump_event_id });
    }

    static encryptionGetHistory(type_id, match_id) {
        return Apis.get('app/encryptionGetHistory', { type_id: type_id, match_id: match_id });
    }

    static encryptionPlayerStats(type_id, match_id) {
        return Apis.get('app/encryptionPlayerStats', { type_id: type_id, match_id: match_id });
    }

    static encryptionShowFocusLeague() {
        return Apis.get('app/encryptionShowFocusLeague');
    }

    static encryptionCompetition() {
        return Apis.get('app/encryptionCompetition');
    }

    static encryptionFocusLeague(league_id) {
        return Apis.get('app/encryptionFocusLeague', { league_id: league_id });
    }

    static encryptionAnalysis(type_id, id) {
        return Apis.get('app/encryptionAnalysis', { type_id: type_id, id: id });
    }

    static encryptionShowFocusEvent(type_id) {
        return Apis.get('app/encryptionShowFocusEvent', { type_id: type_id });
    }

    static encryptionFocusEvent(event_id, del) {
        return Apis.get('app/encryptionFocusEvent', { event_id: event_id, del: del });
    }

    static encryptionHostPaiHang() {
        return Apis.get('app/encryptionHostPaiHang');
    }

    static encryptionOneCom(type_id) {
        return Apis.get('app/encryptionOneCom', { type_id: type_id });
    }

    static encryptionSign(id) {
        return Apis.get('app/encryptionSign', { id: id });
    }

    static encryptionTourists(phone_code, url) {
        return Apis.get('app/encryptionTourists', { phone_code: phone_code, url: url });
    }

    static encryptionHotSearch() {
        return Apis.get('app/encryptionHotSearch');
    }

    static encryptionGetSeaonTableDetail(type_id, competition_id) {
        return Apis.get('app/encryptionGetSeaonTableDetail', { type_id: type_id, competition_id: competition_id });
    }

    static encryptionTeam(type_id, team_id) {
        return Apis.get('app/encryptionTeam', { type_id: type_id, team_id: team_id });
    }

    static encryptionSeasonMatch(type_id, com_id, stage_id, round) {
        return Apis.get('app/encryptionSeasonMatch', { type_id: type_id, com_id: com_id, stage_id: stage_id, round: round });
    }

    static encryptionStage(type_id, com_id) {
        return Apis.get('app/encryptionStage', { type_id: type_id, com_id: com_id });
    }

    static encryptionSeasonStatDetail(type_id, competition_id) {
        return Apis.get('app/encryptionSeasonStatDetail', { type_id: type_id, competition_id: competition_id });
    }

    static encryptionBatchTeamPlayer(type_id, player_id) {
        return Apis.get('app/encryptionBatchTeamPlayer', { type_id: type_id, player_id: player_id });
    }

    static encryptionTeamDetail(type_id, team_id) {
        return Apis.get('app/encryptionTeamDetail', { type_id: type_id, team_id: team_id });
    }

    static encryptionTeamPlayer(type_id, team_id) {
        return Apis.get('app/encryptionTeamPlayer', { type_id: type_id, team_id: team_id });
    }

    static encryptionTeamMatch(type_id, team_id, type) {
        return Apis.get('app/encryptionTeamMatch', { type_id: type_id, team_id: team_id, type: type });
    }

    static encryptionPlayerDetail(type_id, play_id) {
        return Apis.get('app/encryptionPlayerDetail', { type_id: type_id, play_id: play_id });
    }

    static encryptionMatchLineUp(type_id, id) {
        return Apis.get('app/encryptionMatchLineUp', { type_id: type_id, id: id });
    }

    static encryptionSystemMessage() {
        return Apis.get('app/encryptionSystemMessage');
    }

    static uploadImage(data, config) {
        return Apis.post('app/uploadImage', data, config);
    }


    static encryptionAddressCountry(type_id, category_id) {
        return Apis.get('app/encryptionAddressCountry', { type_id: type_id, category_id: category_id });
    }

    static encryptionAddressComList(type_id, category_id, country_id) {
        return Apis.get('app/encryptionAddressComList', { type_id: type_id, category_id: category_id, country_id: country_id });
    }

    static encryptionRoomReport(room_id, content, image) {
        return Apis.get('app/encryptionRoomReport', { room_id: room_id, content: content, image: image });
    }

    static encryptionCustomerInLive(user_id, type) {
        return Apis.get('app/encryptionCustomerInLive', { user_id: user_id, type: type });
    }

    static encryptionVersion(version) {
        return Apis.get('app/encryptionVersion', { version: version });
    }

    static encryptionCountMatchEnd(type_id, date, is_all) {
        return Apis.get('app/encryptionCountMatchEnd', { type_id: type_id, date: date, is_all: is_all });
    }

    static encryptionServerConfig() {
        return Apis.get('app/encryptionServerConfig');
    }

    static encryptionHeartLog(user_type, user_id, phone, phone_code) {
        return Apis.get('app/encryptionHeartLog', { user_type: user_type, user_id: user_id, phone: phone, phone_code: phone_code, client: 'h5' });
    }

    static encryptionMsgShield() {
        return Apis.get('app/encryptionMsgShield');
    }

    static encryptionUpdateUserPwd(customer_id, token, password, other_password) {
        return Apis.get('app/encryptionUpdateUserPwd', { customer_id: customer_id, token: token, password: password, other_password: other_password });
    }

    static encryptionLiveLog(user_id, type, room_id) {
        return Apis.get('app/encryptionLiveLog', { user_id: user_id, type: type, room_id: room_id, client: 'h5' });
    }

    static encryptionGetCity(lat, lng) {
        return Apis.get('app/encryptionGetCity', { lat: lat, lng: lng });
    }

    static encryptionNewsList() {
        return Apis.get('app/encryptionNewsList', {});
    }

    static encryptionNewsContent(id) {
        return Apis.get('app/encryptionNewsContent', { id: id });
    }

    static encryptionQrcode(room_id) {
        return Apis.get('app/encryptionQrcode', { room_id: room_id });
    }

    static checkGroupRule(type, customer_id) {
        return Apis.get('app/checkGroupRule', { type: type, customer_id: customer_id });
    }

    static encryptionUpdatePortrait(file, customer_id) {
        let token = encodeURIComponent(AesUtils.encrypt(AppData.me.token));
        customer_id = encodeURIComponent(AesUtils.encrypt(customer_id));
        var url = Apis.getUrl('app/encryptionUpdatePortrait') + "?token=" + token + "&customer_id=" + customer_id;
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        return axios.post(url, Apis.decodeBase64Content(file.split(',')[1]), config)
    }

    static decodeBase64Content(base64Content) {
        let commonContent = base64Content.replace(/\s/g, '+');
        commonContent = Buffer.from(commonContent, 'base64').toString();
        return commonContent;
    }

    static encryptionQiutxNews(pageSize, pageNum) {
        return Apis.get('app/encryptionNewsData', { pageNum: pageNum, pageSize: pageSize, client_channel: 'bro-news' });
        /*
        let url = '/qiutx-news/web/news/9999/list';
        let clienttype = 'bro-news';
        let t = DateUtils.getCurTime();
        let token = AppUtils.md5(clienttype + url + t).toLowerCase();
        let domain = 'https://api.inckr.com' + url + '?pageSize=' + pageSize + '&pageNum=' + pageNum;
        return axios.get(domain, {
            headers: {
                'client-type': clienttype,
                't': t,
                'token': token
            }
        });*/
    }

    static getUrlHostH5() {
        return Apis.get('app/getUrlHostH5', { from: window.location.origin });
    }
}